module.exports = __webpack_public_path__ + "static/media/invitedFriends_500_750.a9ad53a1.png";